import type {
  IQuotationService,
  QuotationService,
  GetOrderDetailByTokenParams,
  OrderDetail,
} from 'services/quotation';

class QuotationServiceWrapper implements IQuotationService {
  private servicePromise: Promise<QuotationService> = null;

  private async initilizeService() {
    if (!this.servicePromise) {
      this.servicePromise = import('services/quotation').then(
        (mod) => new mod.QuotationService(),
      );
    }
    return this.servicePromise;
  }

  async getOrderDetailByToken(
    params: GetOrderDetailByTokenParams,
  ): Promise<OrderDetail> {
    const service = await this.initilizeService();
    return service.getOrderDetailByToken(params);
  }
}

export default QuotationServiceWrapper;
